export var Constants;
(function (Constants) {
    Constants["ICON_FADED"] = "#cccccc";
    Constants["ICON_DARK_GREY"] = "#8CA4A8";
    Constants["TEXT_TITLE"] = "#000000";
    Constants["TEXT_SUBTITLE"] = "#333333";
})(Constants || (Constants = {}));
